/* eslint-disable @next/next/no-img-element */
import SliderAd from "components/chuyen-gia/slider";
import http from 'utilities/http';
import Image from 'next/image';
import Link from 'next/link';
import dayjs from 'dayjs';
import {SHIT_IMG_URL} from 'utilities/constants';
import { isEmpty } from "lodash";
import Slider from "react-slick";
import { useState, useEffect } from "react";
import { getUrlName } from 'utilities/helper';

export default function index({ dealHots }) {
    const genDealHots = dealHots.filter(x => x.is_active == true).map((item, index) => {
        let imgUrl = '';
        let imgUrlMobile = '';
        if (item.banner.startsWith('/media')) imgUrl = SHIT_IMG_URL + item.banner;
        if (item.banner.startsWith('http')) imgUrl = item.banner;
        if (item.banner.startsWith('[{')) imgUrl = JSON.parse(item.banner)[0][0].url;
    
        if (item.banner_mobile.startsWith('/media')) imgUrlMobile = SHIT_IMG_URL + item.banner_mobile;
        if (item.banner_mobile.startsWith('http')) imgUrlMobile = item.banner_mobile;
        if (item.banner_mobile.startsWith('[{')) {
            const jsonParse = JSON.parse(item.banner_mobile);
            if( !isEmpty(jsonParse)) {
                if (!isEmpty(jsonParse[0])) {
                    imgUrlMobile = jsonParse[0][0].url;
                }
            }
        }
        return (
            <li key={index}>
                <Link href={item.is_landing_page ? `/shop/deal-hot/landing/${item.id}/${getUrlName(item.title)}` : `/shop/deal-hot/${item.id}/${getUrlName(item.title)}`}>
                    <a >
                        <div className="thumb">
                            <img src={imgUrl} alt="" className="pc-only" />
                            <img src={imgUrlMobile || imgUrl} alt="" className="sp-only" />
                        </div>
                        <h3 className="sale_name">{item.title}</h3>
                        <span className="update">{dayjs(item.start_at).format("DD") + "/" + dayjs(item.start_at).format("MM/YYYY")} - {dayjs(item.end_at).format("DD") + "/" + dayjs(item.end_at).format("MM/YYYY")}</span>
                    </a>
                </Link>
            </li>
        );
    });

    const [sideBanner, setSideBanner] = useState({});
    useEffect(() => {
        const fetchBanner = async () => {
            const res1 = await http(`banner/serve?position=4&page=6`, {}, {}, 'v2');
            setSideBanner(res1.data);
        };
        fetchBanner();
    }, []);

    return <section className="main main--shop _deadhot">
        <div className="wrap mt-0">
            <SliderAd positionDesktop="18" pageDesktop="6" positionMobile="20" pageMobile="6" />

            <div className="wrap_banner flashsale_wrap">
                {!isEmpty(dealHots)
                    ? <ul className="wrap_content flashsal_list">
                        {genDealHots}
                    </ul>
                    : <p>Chương trình Deal Hot hiện chưa diễn ra.</p>}
                {sideBanner?.file && <div className="wrap_bnr flashsale_bnr">
                    <a className="hover" href={sideBanner?.external_link}>
                        <Image width={365} height={690} layout="responsive" src={sideBanner?.file} alt="" />
                    </a>
                </div>}
            </div>
        </div>
    </section>;
}

export const getStaticProps = async () => {
    const dealHotParams = {
        size: 12,
    };

    const res = await Promise.all([
        http('/rest/V1/vendors/list-dealhot', dealHotParams)
    ]);

    return {
        props: {
            // dealHots: res[0].items,
            dealHots: !isEmpty(res[0]?.items) ? res[0].items : [],
        },
        revalidate: 30,
    };
};